// extracted by mini-css-extract-plugin
export default {"heading":"Courses_heading__2BpQH","courses_container":"Courses_courses_container__o5rH6","card_container":"Courses_card_container__eSiv-","courses":"Courses_courses__wH62Y"};